// ABOUTME: Builds parser item table actions for applicant CV upload operations.
// ABOUTME: Prevents rows without parsed CV data from opening manual verification.
import { navigate } from "@gatsbyjs/reach-router";
import { actionsTableListType } from "customHooks/useCompleoSimpleList";
import {
    canReviewParserItem,
    getParserItemActionState,
    getParserItemReviewPath,
    type ParserItemRowData
} from "./parserItemActions";

const useActionsTable = (
    setOpenModalAuto: React.Dispatch<
        React.SetStateAction<{
            open: boolean;
            operationId: string;
            refreshListFunction: () => void;
            itemId?: string | undefined;
        }>
    >,
    t: (key: string) => string
) => {
    return (refreshListFunction: () => void) => {
        const result: actionsTableListType = [
            (rowData: ParserItemRowData) => {
                const actionState = getParserItemActionState(rowData);

                return {
                    icon: "edit",
                    tooltip: actionState.disabled
                        ? t("parserItemDataUnavailable")
                        : t("COMPLEOGENERAL_Edit"),
                    onClick: (event: unknown, rowData: ParserItemRowData) => {
                        if (!canReviewParserItem(rowData)) {
                            return;
                        }

                        navigate(getParserItemReviewPath(rowData));
                    },
                    hidden: actionState.hidden,
                    disabled: actionState.disabled
                };
            },
            (rowData: ParserItemRowData) => {
                const actionState = getParserItemActionState(rowData);

                return {
                    icon: "check",
                    tooltip: actionState.disabled
                        ? t("parserItemDataUnavailable")
                        : t("btnProcess"),
                    onClick: (event: unknown, rowData: ParserItemRowData) => {
                        if (!canReviewParserItem(rowData)) {
                            return;
                        }

                        setOpenModalAuto({
                            open: true,
                            operationId: rowData.pk.split(":")[1],
                            refreshListFunction: refreshListFunction,
                            itemId: rowData.skGS1pk.split(":")[1]
                        });
                    },
                    hidden: actionState.hidden,
                    disabled: actionState.disabled
                };
            }
        ];

        return result;
    };
};

export default useActionsTable;
